import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AclToolsService } from '../../../../../acl/tools/acl-tools.service';
import { AclResource } from '../../../../../acl/tools/decorators/acl-resource';

export const ACL_RESOURCES = {
  PATRON_ACCESS: 'getPatron',
};

@Injectable({
  providedIn: 'root',
})
export class PatronAclService {
  @AclResource(ACL_RESOURCES.PATRON_ACCESS)
  public canSeePatron$: Observable<boolean>;

  constructor(
    public aclTools: AclToolsService,
  ) {}
}
